export default "__VITE_ASSET__QvEcpjIa__"